/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerString } from '../models/EntityModelResponseContainerString';
import type { EntityModelResponseContainerThemeConfigurationDto } from '../models/EntityModelResponseContainerThemeConfigurationDto';
import type { EntityModelResponseContainerUploadInfoDto } from '../models/EntityModelResponseContainerUploadInfoDto';
import type { ThemeConfigurationDto } from '../models/ThemeConfigurationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ThemeConfigurationControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/theme_configuration',
        });
    }
    /**
     * @returns EntityModelResponseContainerThemeConfigurationDto OK
     * @throws ApiError
     */
    public static readDataForProgramThemeConfigurationPage(): CancelablePromise<EntityModelResponseContainerThemeConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/theme_configuration',
        });
    }
    /**
     * @returns EntityModelResponseContainerThemeConfigurationDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: ThemeConfigurationDto,
    }): CancelablePromise<EntityModelResponseContainerThemeConfigurationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/theme_configuration',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerThemeConfigurationDto OK
     * @throws ApiError
     */
    public static update({
        requestBody,
    }: {
        requestBody: ThemeConfigurationDto,
    }): CancelablePromise<EntityModelResponseContainerThemeConfigurationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/theme_configuration',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerString OK
     * @throws ApiError
     */
    public static sanitizeSvg({
        formData,
    }: {
        formData?: {
            file: Blob;
        },
    }): CancelablePromise<EntityModelResponseContainerString> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/theme_configuration/sanitizeSvg',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @returns EntityModelResponseContainerUploadInfoDto OK
     * @throws ApiError
     */
    public static uploadSvg({
        formData,
    }: {
        formData?: {
            file: Blob;
        },
    }): CancelablePromise<EntityModelResponseContainerUploadInfoDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/theme_configuration/uploadSvg',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
